export class StateDto {
  id: number;
  acronym: string;
  name: string;
}
